import { render, staticRenderFns } from "./modal-backoffice-gerenciar-cirurgia-conjunta.vue?vue&type=template&id=7793490e"
import script from "./modal-backoffice-gerenciar-cirurgia-conjunta.vue?vue&type=script&lang=ts"
export * from "./modal-backoffice-gerenciar-cirurgia-conjunta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports